import React from "react";
import { useParams } from "react-router-dom";
import data from "../../json/Agiletesting/Agiletexting3.json";

const Agilitesting3 = () => {
  const { testing } = useParams();

  return (
    <div className="2xl:container flex justify-center p-4 md:p-0  flex-col items-center w-full">
      <div className="flex flex-col md:flex-row gap-4 md:gap-[72px]">
        <div className="bg-gray py-6 md:p-12">
          <p className="text-16 md:text-20 text-white font-medium text-center px-2 md:px-[64px] py-5 md:py-6 bg-21273D">
            {data[testing].title}
          </p>
          <div className="bg-white p-4 md:p-8 my-2 md:my-0 flex flex-col gap-3 md:gap-6">
            {data[testing].para.map((item, id) => (
              <div className="bg-white flex gap-3 text-14 md:text-18">
                <img
                  src={process.env.PUBLIC_URL + "/images/Agiletesting/dot.svg"}
                  alt="dot"
                  className=""
                />
                <p className="text-secondaryblack">{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="md:mt-20 md:w-[80%] text-left md:pr-10">
          <p className="text-20 md:text-40 text-21273D mb-3 md:mb-6">
            {data[testing].title1}
          </p>
          <p className="text-14 md:text-18 text-secondaryblack">
            {data[testing].para1}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Agilitesting3;
